var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-2"},[_c(_setup.PpdShopTop),_vm._v(" "),_c('nuxt-child')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }